<template>
    <div class="metrics">
        <button @click="clearLoadEvent">Очистить</button>
        <button @click="copyLoadEvent">Скопировать в буфер</button>
        <button @click="openFullDebug">Открыть окно с графиками</button>
        <canvas id="loadEvent" ref="loadEvent" width="640" height="15" style="border:1px solid #000000;"></canvas>
        <canvas id="bitrateTimerange" ref="bitrateTimerange" width="640" height="100" style="border:1px solid #000000;"></canvas>
    </div>
</template>
<script>
    import Hls from 'hls.js';
    import Jsonpack from 'jsonpack';

    import {mapState, mapActions} from 'vuex';

    export default {
        data() {
            return {
                lastSeekingIdx: 0,
                loadEventFilter: 0
            }
        },
        props: ['hls'],
        computed: {
            ...mapState({
                debugSettings: state => state.debug.debugSettings
            })
        },
        methods: {
            openFullDebug() {
                let url = 'https://video-dev.github.io/hls.js/demo/metrics.html#data=' + this.getMetrics();
                window.open(url)
            },
            getMetrics() {
                let json = JSON.stringify(this.$parent.events);
                let jsonpacked = Jsonpack.pack(json);
                console.log("packing JSON from " + json.length + " to " + jsonpacked.length + " bytes");
                return btoa(jsonpacked);
            },
            copyTextToClipboard(text) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Copying text command was ' + msg);
                } catch (err) {
                    console.log('Oops, unable to copy');
                }
                document.body.removeChild(textArea);
            },
            copyLoadEvent() {
                this.copyTextToClipboard(this.getMetrics());
            },
            clearLoadEvent() {
                this.loadEventFilter = this.$parent.events.load.length - 1;
            },
            showMetrics() {
//                if (this.metricsEnabled) {
                let width = window.innerWidth - 30;
                this.$refs.loadEvent.width = this.$refs.bitrateTimerange.width = width;
//                }
            },
            canvasLoadEventUpdate(canvas, minTime, maxTime, events) {
                var eventLeftMargin = 180;
                var eventRightMargin = 0;
                var ctx = canvas.getContext('2d');
                for (var i = 0, y_offset = 20; i < events.length; i++) {
                    var event = events[i], start = event.time;
//                    if ((start >= minTime && start <= maxTime)) {
                    if (i > this.loadEventFilter) {
                        y_offset += 20;
                    }
//                    }
                }
                canvas.height = y_offset;
                ctx.fillStyle = "green";
                ctx.globalAlpha = 0.5;
                ctx.fillRect(0, 0, eventLeftMargin, canvas.height);
                ctx.fillRect(canvas.width - eventRightMargin, 0, eventRightMargin, canvas.height);
                ctx.globalAlpha = 1;

                //draw legend
                var x_offset = 5;
                ctx.font = "12px Arial";

                var legend = "load event";
                ctx.fillStyle = "black";
                ctx.fillText(legend, x_offset, 15);
                x_offset = eventLeftMargin + 5;


                legend = 'start - end';
                ctx.fillStyle = "black";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                legend = '[latency';
                ctx.fillStyle = "orange";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                legend = 'loading';
                ctx.fillStyle = "green";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                legend = 'parsing';
                ctx.fillStyle = "blue";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                legend = 'appending]';
                ctx.fillStyle = "red";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                legend = 'size bitrate';
                ctx.fillStyle = "black";
                ctx.fillText(legend, x_offset, 15);
                x_offset += ctx.measureText(legend).width + 5;

                for (i = 0, y_offset = 20; i < events.length; i++) {
                    var event = events[i], start = Math.round(event.time);
//                    if ((start >= minTime && start <= maxTime)) {
                    if (i > this.loadEventFilter) {
                        this.canvasDrawLoadEvent(ctx, y_offset, event, minTime, maxTime);
                        y_offset += 20;
                    }
//                    }
                }
            },
            canvasDrawLoadEvent(ctx, yoffset, event, minTime, maxTime) {
                let eventLeftMargin = 180;
                let eventRightMargin = 0;
                let legend, offset, x_start, x_w,
                    networkChartStart = eventLeftMargin,
                    networkChartWidth = ctx.canvas.width - eventLeftMargin - eventRightMargin,
                    tend = Math.round(event.time + event.duration + event.latency);
                let xoffset = networkChartStart + 5;

                // draw start
                ctx.fillStyle = "black";
                ctx.font = "12px Arial";
                legend = Math.round(event.time);
                offset = ctx.measureText(legend).width + 5;
//                x_start = (networkChartStart - offset) * (event.time - minTime) / (maxTime - minTime);
//                ctx.fillText(legend, x_start, yoffset + 12);
                ctx.fillText(legend, xoffset, yoffset + 12);

                xoffset += offset;

                //draw latency rectangle
                ctx.fillStyle = "orange";
//                x_start = networkChartStart + networkChartWidth * (event.time - minTime) / (maxTime - minTime);
                x_start = networkChartStart * (event.time - minTime);
                x_w = networkChartWidth * event.latency / (maxTime - minTime);
//                ctx.fillRect(x_start, yoffset, x_w, 15);
                ctx.fillRect(xoffset, yoffset, x_w, 15);

                xoffset += x_w;

                //draw download rectangle
                ctx.fillStyle = "green";
                x_start = networkChartStart + networkChartWidth * (event.time + event.latency - minTime) / (maxTime - minTime);
                x_w = networkChartWidth * event.load / (maxTime - minTime);
//                ctx.fillRect(x_start, yoffset, x_w, 15);
                ctx.fillRect(xoffset, yoffset, x_w, 15);

                xoffset += x_w;

//                console.log('(maxTime - minTime)', (maxTime - minTime));

                if (event.parsing) {
                    //draw parsing rectangle
                    ctx.fillStyle = "blue";
                    x_start = networkChartStart + networkChartWidth * (event.time + event.latency + event.load - minTime) / (maxTime - minTime);
                    x_w = networkChartWidth * event.parsing / (maxTime - minTime);
//                    ctx.fillRect(x_start, yoffset, x_w, 15);
                    ctx.fillRect(xoffset, yoffset, x_w, 15);

                    xoffset += x_w;

                    if (event.buffer) {
                        //draw buffering rectangle
                        ctx.fillStyle = "red";
                        x_start = networkChartStart + networkChartWidth * (event.time + event.latency + event.load + event.parsing - minTime) / (maxTime - minTime);
                        x_w = networkChartWidth * event.buffer / (maxTime - minTime);
//                        ctx.fillRect(x_start, yoffset, x_w, 15);
                        ctx.fillRect(xoffset, yoffset, x_w, 15);

                        xoffset += x_w;
                    }
                }

                xoffset += 5;

                //draw end time
                ctx.fillStyle = "black";
                ctx.font = "12px Arial";
                legend = tend;
                x_start += x_w + 5;
//                ctx.fillText(legend, x_start, yoffset + 12);
                ctx.fillText(legend, xoffset, yoffset + 12);
                x_start += ctx.measureText(legend).width + 5;

                xoffset += ctx.measureText(legend).width + 5;

                legend = "[" + Math.round(event.latency);
                ctx.fillStyle = "orange";
//                ctx.fillText(legend, x_start, yoffset + 12);
                ctx.fillText(legend, xoffset, yoffset + 12);
                x_start += ctx.measureText(legend).width + 5;

                xoffset += ctx.measureText(legend).width + 5;

                legend = Math.round(event.load);
                if (!event.parsing) legend += "]";
                ctx.fillStyle = "green";
//                ctx.fillText(legend, x_start, yoffset + 12);
                ctx.fillText(legend, xoffset, yoffset + 12);
                x_start += ctx.measureText(legend).width + 5;

                xoffset += ctx.measureText(legend).width + 5;

                if (event.parsing) {
                    legend = Math.round(event.parsing);
                    if (!event.buffer) legend += "]";
                    ctx.fillStyle = "blue";
//                    ctx.fillText(legend, x_start, yoffset + 12);
                    ctx.fillText(legend, xoffset, yoffset + 12);
                    x_start += ctx.measureText(legend).width + 5;

                    xoffset += ctx.measureText(legend).width + 5;

                    if (event.buffer) {
                        legend = Math.round(event.buffer) + "]";
                        ctx.fillStyle = "red";
//                        ctx.fillText(legend, x_start, yoffset + 12);
                        ctx.fillText(legend, xoffset, yoffset + 12);
                        x_start += ctx.measureText(legend).width + 5;

                        xoffset += ctx.measureText(legend).width + 5;
                    }
                }

                if (event.size) {
                    if (event.size > 1000 * 1000) {
                        legend = (event.size / 1000000).toFixed(1) + 'MB';
                    } else {
                        legend = Math.round(event.size / 1000) + 'kB';
                    }
                    ctx.fillStyle = "black";
//                    ctx.fillText(legend, x_start, yoffset + 12);
                    ctx.fillText(legend, xoffset, yoffset + 12);
                    x_start += ctx.measureText(legend).width + 5;

                    xoffset += ctx.measureText(legend).width + 5;
                }

                if (event.bw) {
                    if (event.bw > 1000) {
                        legend = (event.bw / 1000).toFixed(1) + 'Mbps';
                    } else {
                        legend = event.bw + ' kbps';
                    }
                    ctx.fillStyle = "black";
//                    ctx.fillText(legend, x_start, yoffset + 12);
                    ctx.fillText(legend, xoffset, yoffset + 12);
                    x_start += ctx.measureText(legend).width + 5;

                    xoffset += ctx.measureText(legend).width + 5;
                }

                // draw event name
                ctx.fillStyle = "black";
                ctx.font = "12px Arial";
                legend = event.type;
                if (event.id2 !== undefined) {
                    legend += ' ' + event.id2;
                }
                if (event.id !== undefined) {
                    if (event.type.indexOf('fragment') !== -1) {
                        legend += ' @';
                    }
                    legend += ' ' + event.id;
                }
                if (event.start !== undefined) {
                    legend += ' [' + event.start + ',' + event.end + ']';
                }
                ctx.fillText(legend, 5, yoffset + 15);
            },
            canvasBitrateEventUpdate(canvas, minTime, maxTime, windowMinTime, windowMaxTime, levelEvents, bitrateEvents) {
                var eventLeftMargin = 180;
                var eventRightMargin = 0;
                var ctx = canvas.getContext('2d'),
                    bufferChartStart = eventLeftMargin,
                    bufferChartWidth = ctx.canvas.width - eventLeftMargin - eventRightMargin,
                    x_offset = 0, y_offset = 0,
                    event, maxLevel, minLevel, sumLevel, maxBitrate, minBitrate, sumDuration;
                ctx.clearRect(0, 0, canvas.width, canvas.height);

//                console.log(levelEvents);
//                console.log(levelEvents.length);

                if (levelEvents.length === 0) {
                    return;
                }

                maxBitrate = minBitrate = bitrateEvents[0].bitrate;
                sumLevel = sumDuration = 0;
                for (var i = 0; i < bitrateEvents.length; i++) {
                    sumLevel += bitrateEvents[i].duration * bitrateEvents[i].level;
                    sumDuration += bitrateEvents[i].duration;
                    maxBitrate = Math.max(maxBitrate, bitrateEvents[i].bitrate);
                    minBitrate = Math.min(minBitrate, bitrateEvents[i].bitrate);
                }

                maxLevel = minLevel = levelEvents[0].id;
                for (var i = 0; i < levelEvents.length; i++) {
                    maxLevel = Math.max(maxLevel, levelEvents[i].id);
                    minLevel = Math.min(minLevel, levelEvents[i].id);
                }

                ctx.fillStyle = "green";
                ctx.globalAlpha = 0.5;
                ctx.fillRect(0, 0, eventLeftMargin, canvas.height);
//                ctx.fillStyle = "red";
                ctx.fillRect(canvas.width - eventRightMargin, 0, eventRightMargin, canvas.height);
                ctx.globalAlpha = 1;

                x_offset = 5;
                y_offset = 0;
                ctx.fillStyle = "black";
                ctx.font = "15px Arial";

                y_offset += 15;
                var legend = 'last bitrate:' + (bitrateEvents[bitrateEvents.length - 1].bitrate / 1000).toFixed(2) + "Mb/s";
                ctx.fillText(legend, x_offset, y_offset);

                y_offset += 15;
                legend = 'min bitrate:' + (minBitrate / 1000).toFixed(2) + "Mb/s";
                ctx.fillText(legend, x_offset, y_offset);

                y_offset += 15;
                legend = 'max bitrate:' + (maxBitrate / 1000).toFixed(2) + "Mb/s";
                ctx.fillText(legend, x_offset, y_offset);

                y_offset += 15;
                legend = 'min/last/max level:' + minLevel + '/' + levelEvents[levelEvents.length - 1].id + '/' + maxLevel;
                ctx.fillText(legend, x_offset, y_offset);

                y_offset += 15;
                legend = 'nb level switch:' + (levelEvents.length - 1);
                ctx.fillText(legend, x_offset, y_offset);

                y_offset += 15;
                legend = 'average level:' + (sumLevel / sumDuration).toFixed(2);
                ctx.fillText(legend, x_offset, y_offset);

                maxBitrate *= 1.1;

                ctx.strokeStyle = "blue";
                ctx.beginPath();
//                console.log(bitrateEvents);
//                console.log('======================');
                ctx.moveTo(bufferChartStart, ctx.canvas.height);
                for (var i = 0; i < bitrateEvents.length; i++) {
                    event = bitrateEvents[i];
//                    console.log(event);
                    x_offset = bufferChartStart + (bufferChartWidth * (event.time - minTime)) / (maxTime - minTime);
                    y_offset = ctx.canvas.height * (1 - event.bitrate / maxBitrate);
                    ctx.lineTo(x_offset, y_offset);
//                    ctx.stroke();
                }
//                ctx.strokeStyle = "red";
                ctx.lineTo(bufferChartStart + bufferChartWidth, y_offset); // Доводит линию до конца графика
                ctx.stroke();

                ctx.strokeStyle = "black";
                ctx.beginPath();
                x_offset = bufferChartStart;
                y_offset = ctx.canvas.height;
                ctx.moveTo(x_offset, y_offset);
//                console.log(levelEvents);
                for (var i = 0; i < levelEvents.length; i++) {
                    event = levelEvents[i];
                    x_offset = bufferChartStart + (bufferChartWidth * (event.time - minTime)) / (maxTime - minTime);
                    ctx.lineTo(x_offset, y_offset);
                    y_offset = ctx.canvas.height * (1 - event.bitrate / maxBitrate);
                    ctx.lineTo(x_offset, y_offset);
                }
                ctx.lineTo(bufferChartStart + bufferChartWidth, y_offset);
                ctx.stroke();

//                ctx.globalAlpha = 0.7;
//                ctx.fillStyle = "grey";
//                var x_start = bufferChartStart;
//                var x_w = bufferChartWidth * (windowMinTime - minTime) / (maxTime - minTime);
//                ctx.fillRect(x_start, 0, x_w, canvas.height);
//                var x_start = bufferChartStart + bufferChartWidth * (windowMaxTime - minTime) / (maxTime - minTime);
//                var x_w = canvas.width - x_start - eventRightMargin;
//                ctx.fillRect(x_start, 0, x_w, canvas.height);
//                ctx.globalAlpha = 1;

            },
            refreshCanvas() {
//                if (this.metricsEnabled) {
                if (this.debugSettings) {
                    if (this.debugSettings.metricsEnabled) {
                        try {
                            var windowTime = this.getWindowTimeRange();
                            this.canvasBitrateEventUpdate(this.$refs.bitrateTimerange, 0, windowTime.now, windowTime.min, windowTime.max, this.$parent.events.level, this.$parent.events.bitrate);
                            this.canvasLoadEventUpdate(this.$refs.loadEvent, windowTime.min, windowTime.max, this.$parent.events.load);
                        } catch (err) {
                            console.log("refreshCanvas error:" + err.message);
                        }
                    }
                }
            },
            getWindowTimeRange() {
                let tnow, minTime, maxTime;
                if (this.$parent.events.buffer.length) {
                    tnow = this.$parent.events.buffer[this.$parent.events.buffer.length - 1].time;
                } else {
                    tnow = 0;
                }
                // let's show the requested window
                minTime = Math.max(0, tnow - 20000);
                maxTime = Math.min(minTime + 20000, tnow);
                return {min: minTime, max: maxTime, now: tnow}
            },
            handleAllVideoEvents() {
                this.$parent.player.addEventListener('resize', this.handleVideoEvent);
                this.$parent.player.addEventListener('seeking', this.handleVideoEvent);
                this.$parent.player.addEventListener('seeked', this.handleVideoEvent);
                this.$parent.player.addEventListener('pause', this.handleVideoEvent);
                this.$parent.player.addEventListener('play', this.handleVideoEvent);
                this.$parent.player.addEventListener('canplay', this.handleVideoEvent);
                this.$parent.player.addEventListener('canplaythrough', this.handleVideoEvent);
                this.$parent.player.addEventListener('ended', this.handleVideoEvent);
                this.$parent.player.addEventListener('playing', this.handleVideoEvent);
                this.$parent.player.addEventListener('error', this.handleVideoEvent);
                this.$parent.player.addEventListener('loadedmetadata', this.handleVideoEvent);
                this.$parent.player.addEventListener('loadeddata', this.handleVideoEvent);
                this.$parent.player.addEventListener('durationchange', this.handleVideoEvent);
            },
            handleVideoEvent(evt) {
                let data = '';
                switch (evt.type) {
                    case 'durationchange':
                        if (evt.target.duration - this.$parent.lastDuration <= 0.5) {
                            // some browsers reports several duration change events with almost the same value ... avoid spamming video events
                            return;
                        }
                        this.$parent.lastDuration = evt.target.duration;
//                        this.$parent.debugOptions.lastDuration = evt.target.duration;
//                        this.$set(this.$parent.events.video[this.$parent.bufferingIdx], 'duration', bufferingDuration);
                        data = Math.round(evt.target.duration * 1000);
                        break;
                    case 'resize':
                        data = evt.target.videoWidth + '/' + evt.target.videoHeight;
                        break;
                    case 'loadedmetadata':
                    case 'loadeddata':
                    case 'canplay':
                    case 'canplaythrough':
                    case 'ended':
                    case 'seeking':
                    case 'seeked':
                    case 'play':
                    case 'playing':
                        this.$parent.lastStartPosition = evt.target.currentTime;
                    case 'pause':
                    case 'waiting':
                    case 'stalled':
                    case 'error':
                        data = Math.round(evt.target.currentTime * 1000);
                        if (evt.type === 'error') {
                            var errorTxt;
                            var mediaError = evt.currentTarget.error;
                            switch (mediaError.code) {
                                case mediaError.MEDIA_ERR_ABORTED:
                                    errorTxt = "You aborted the video playback";
                                    break;
                                case mediaError.MEDIA_ERR_DECODE:
                                    errorTxt = "The video playback was aborted due to a corruption problem or because the video used features your browser did not support";
                                    break;
                                case mediaError.MEDIA_ERR_NETWORK:
                                    errorTxt = "A network error caused the video download to fail part-way";
                                    break;
                                case mediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
                                    errorTxt = "The video could not be loaded, either because the server or network failed or because the format is not supported";
                                    break;
                            }
                            if (mediaError.message) {
                                errorTxt += ' - ' + mediaError.message;
                            }
                            console.error(errorTxt);
                        }
                        break;
                    default:
                        break;
                }
                var event = {time: performance.now() - this.$parent.events.t0, type: evt.type, name: data};
                this.$parent.events.video.push(event);
                if (evt.type === 'seeking') {
                    this.lastSeekingIdx = this.$parent.events.video.length - 1;
                }
                if (evt.type === 'seeked') {
                    this.$set(this.$parent.events.video[this.lastSeekingIdx], 'duration', event.time - this.$parent.events.video[this.lastSeekingIdx].time);
                }
            }
        },
        mounted() {
            this.showMetrics();
        },
    }
</script>
<style>
    .metrics {
        background: #ffffff;
        padding-bottom: 100px;
    }
</style>


// WEBPACK FOOTER //
// DebugMetrics.vue?47176f05